var ABTestUIHelper = {
    replaceContent: function (selector, newContent) {
        var element = document.querySelector(selector);
        if (element) {
            element.innerHTML = newContent;
        }
    },
    redirect: function (url) {
        window.location.href = url;
    }
};
